import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateCryptocurrencyForm } from "web_myplann/Portfolio/Pages/CryptocurrencyCreate/CreateCryptocurrencyForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddCryptocurrencyPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddCryptocurrency.title)}>
			<CreateCryptocurrencyForm />
		</PortfolioAddLayout>
	);
};
